import { useState, useCallback } from "react";
import {
  createAudience,
  updateAudience,
  deleteAudience,
} from "../services/audienceService";
import type {
  CreateAudienceInput,
  UpdateAudienceInput,
} from "@event-planner/shared";

export function useCreateAudience() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const create = useCallback(async (input: CreateAudienceInput) => {
    setLoading(true);
    setError(null);
    try {
      return await createAudience(input);
    } catch (err) {
      const e = err instanceof Error ? err : new Error("Create audience failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { create, loading, error };
}

export function useUpdateAudience() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const update = useCallback(async (input: UpdateAudienceInput) => {
    setLoading(true);
    setError(null);
    try {
      return await updateAudience(input);
    } catch (err) {
      const e = err instanceof Error ? err : new Error("Update audience failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { update, loading, error };
}

export function useDeleteAudience() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const remove = useCallback(async (audienceId: string) => {
    setLoading(true);
    setError(null);
    try {
      return await deleteAudience({ audienceId });
    } catch (err) {
      const e = err instanceof Error ? err : new Error("Delete audience failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { remove, loading, error };
}
